<template>
  <div class="mapBox" id="mapBox">
    <baidu-map v-bind:style="mapStyle" class="bm-view" mapType="BMAP_SATELLITE_MAP" :center="center"
               :zoom="zoom"
               ak="cFjSMpp64eGNPQZ63hYfoh6POgmZdmr0" :scroll-wheel-zoom="true"
               @ready="mapHandler" :map-click="false">
      <bm-polygon :path="pointList" stroke-color="#48d68a" fillColor="#1C1CB8" :fillOpacity=".5" :strokeOpacity="0.8" :strokeWeight="3" :editing="editing" @lineupdate="updatePolygonPath"/>
      <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
      <bm-control anchor="BMAP_ANCHOR_BOTTOM_RIGHT">
        <button class="btn toEdit" @click="toEdit"><van-icon name="edit" /><span>编辑</span></button>
        <button class="btn toDel" @click="toDel"><van-icon name="delete" /><span>删除</span></button>
      </bm-control>
    </baidu-map>
  </div>
</template>

<script>
import {
  BaiduMap,
  BmPolygon,
  BmNavigation,
  BmControl,
} from 'vue-baidu-map';

export default {
  components: {
    BaiduMap,
    BmPolygon,
    BmNavigation,
    BmControl,
  },
  props: {
    pointList: {
      type: Array,
      default: []
    },
  },
  watch: {
    pointList(newValue) {
      console.log(newValue)
      this.polygonPath = newValue || [];
    },
  },
  data() {
    return {
      BMap: {},
      map: {},
      center: {lng: '', lat: ''},
      zoom: 16,
      mapStyle: {
        width: '100%',
        height: '51vw'
      },
      polygonPath: [],
      editing: false,
      iconUrl: 'https://api.map.baidu.com/images/marker_red_sprite.png',
    }
  },
  mounted() {
    document.getElementById('mapBox').removeEventListener('touchmove', (event) => {
      event.preventDefault();
    }, false);
    this.polygonPath = this.pointList || [];
  },
  methods: {
    getMapPointAvageNum(list) {
      let lens = list.length;
      if(!lens) return
      let lat = 0;
      let lng = 0;
      list.forEach((s, i) => {
        lat += s.lat;
        lng += s.lng
      });
      lat = lat / lens;
      lng = lng / lens;
      this.center = { lng, lat }
    },
    updatePolygonPath (e) {
      this.polygonPath = e.target.getPath()
    },
    addPolygonPoint () {
      this.polygonPath.push({lng: 116.404, lat: 39.915})
    },
    mapHandler({BMap, map}) {
      this.BMap = BMap; // 核心类
      this.map = map; // 地图实例
      this.getMapPointAvageNum(this.polygonPath);
      // this.getCurlocation(); // 定位
    },
    getCurlocation() { // 获取浏览器当前定位
      if (!this.BMap) return false;
      let BMap = this.BMap;
      let geolocation = new BMap.Geolocation();
      let _this = this;
      geolocation.getCurrentPosition(r => {
        _this.center = r.point;
      });
    },
    toEdit() {
      this.$emit('toEditMap', true)
    },
    toDel() {
      this.$dialog.confirm({
        title: '确认删除所绘图形？',
        message: '',
      }).then(() => {
        this.$emit('toDelMap', true)
      }).catch(cancel => {
        console.log(cancel)
      })
    },
    /***
     * 确认
     */
    confirm() {
    },
    /***
     * 取消
     */
    cancel() {
    }
  }
}
</script>

<style lang="stylus">
.mapBox
  height 200px
  width 100%
  display flex
  flex-direction column
  overflow hidden

  .bm-view
    flex 1
    height 100%
    width 100%

    .anchorBL
      display none

    .anchorTL
      width 100%
      padding 9px

      .serachinput
        width 96%
        display block
        padding 9px
        box-sizing border-box
        border 1px solid #dddee1
        line-height 20px
        font-size 14px
        height 38px
        color #333
        position relative
        border-radius 4px
        box-shadow #666 0px 0px 10px

  .footer
    position fixed
    bottom 0
    padding 10px 0
    z-index 999
    width 100%
    background #f1f1f1
    box-shadow #666 0px 0px 10px

    .submit
      text-align center

      button
        width 30%
        margin 0 5%

  .pointImg
    position fixed
    top 50%
    left 50%
    margin-top -30px
    margin-left -16px
    z-index 9999

span
  overflow inherit

.anchorBR {
  position: absolute
  bottom: 0;
  right: 0;
}
.btn {
  outline: none;
  border: 0;
  height: 7vw;
  line-height: 5vw;
  margin: 1vw;
  padding: 1vw 2vw;
  border-radius: 1vw;
  color: #fff;
  i, span {
    vertical-align: middle;
  }
  i {
    font-size: 4vw;
  }
  span {
    margin-left: 2vw;
    font-size: 3.5vw;
  }
  &.toEdit {
    background: #07c160;
  }
  &.toDel {
    background: #e4393c;
  }

}
</style>
